"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SliderHandle = void 0;
var tslib_1 = require("tslib");
var classnames_1 = tslib_1.__importDefault(require("classnames"));
var react_1 = tslib_1.__importStar(require("react"));
var bubble_1 = require("../bubble");
var popover_1 = require("../popover");
function SliderHandle(_a) {
    var _b;
    var classPrefix = _a.classPrefix, value = _a.value, vertical = _a.vertical, offset = _a.offset, dragging = _a.dragging, enableTip = _a.enableTip, tipFormatter = _a.tipFormatter;
    var _c = tslib_1.__read(react_1.useState(false), 2), hovering = _c[0], setHovering = _c[1];
    var scheduleRef = react_1.useRef(null);
    var offsetKey = vertical ? "bottom" : "left";
    react_1.useEffect(function () {
        if (scheduleRef.current) {
            scheduleRef.current();
        }
    }, [offset]);
    return (react_1.default.createElement(popover_1.Popover, { visible: enableTip && (dragging || hovering), overlayStyle: {
            pointerEvents: "none",
        }, placement: vertical ? "left" : "top", transitionTimeout: 0, overlay: function (_a) {
            var placement = _a.placement, scheduleUpdate = _a.scheduleUpdate;
            scheduleRef.current = scheduleUpdate;
            var tips = tipFormatter(value);
            return (tips !== null && (react_1.default.createElement(bubble_1.BubbleContent, { placement: placement }, tips)));
        } },
        react_1.default.createElement("div", { className: classPrefix + "-slider__handle", style: (_b = {}, _b[offsetKey] = offset + "%", _b), onMouseEnter: function () { return setHovering(true); }, onMouseLeave: function () { return setHovering(false); } },
            react_1.default.createElement("span", { className: classnames_1.default(classPrefix + "-slider__handle-inner", {
                    "is-active": hovering || dragging,
                }) }))));
}
exports.SliderHandle = SliderHandle;
SliderHandle.displayName = "SliderHandle";
//# sourceMappingURL=SliderHandle.js.map